import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ButtonCtaComponent } from '@components/button-cta/button-cta.component';

@Component({
  selector: 'app-quiz-footer-cta',
  templateUrl: './quiz-footer-cta.html',
  standalone: true,
  imports: [ButtonCtaComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuizFooterCtaComponent {
  readonly label = input.required<string>();
  /** Optional icon-font class (e.g. cs-icon-camera) rendered after the label. */
  readonly icon = input<string>('');
  readonly disabled = input<boolean>(false);
  /** Shows the button spinner while the answer is being submitted / the next question loads. */
  readonly loading = input<boolean>(false);
  readonly pressed = output<void>();

  onClick(): void {
    if (this.disabled() || this.loading()) return;
    this.pressed.emit();
  }
}
